

export const GearTypes = Object.freeze({
    'ON_PREM_SERVER': {
        fullname: 'AutoPilot Server',
        name: 'Server',
        rightNavTitle: 'OnboardOnPremServer',
        stateKey: 'orgOnPremServers',
        deviceType: 'ON_PREM_SERVER',
    },
    'ROBOT': {
        fullname: 'AIRstation Robot',
        name: 'Robot',
        rightNavTitle: 'OnboardRobot',
        stateKey: 'orgRobots',
        deviceType: 'ROBOT',
    },
    'INSTANCE': {
        fullname: 'Cloud Compute Instance',
        name: 'Instance',
        rightNavTitle: 'OnboardInstance',
        stateKey: 'orgInstances',
        deviceType: 'INSTANCE',
    }
})

export const deviceTypeFilterOptions = [
    { value: 'ALL', label: 'All' },
    { value: 'ROBOT', label: 'AIR One™' },
    { value: 'ON_PREM_SERVER', label: 'AutoPilot Server' },
    { value: 'VIMIX_MAIN', label: 'Main Switcher' },
    { value: 'VIMIX_REPLY', label: 'Replay' },
    { value: 'SRT_GATEWAY', label: 'Gateway' },
    { value: 'AUTOPILOT', label: 'AutoPilot' },
];

export const gearSubscriptionStatusFilterOptions = [
    { value: 'ALL', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'in_dunning', label: 'In Dunning' },
    { value: 'pending', label: 'Pending' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'expired', label: 'Expired' },
    { value: 'NONE', label: 'No Subscription' },
];